import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const reseñas = [
    {
      nombre: "Alejandra Rivas",
      cargo: "Gerente Financiera, Puebla",
      fecha: "Lunes 10 de Marzo, 2025",
      opinion: "El servicio de Asesoría Fiscal nos ayudó a optimizar nuestros procesos contables. Muy profesional y atento.",
    },
    {
      nombre: "Santiago Morales",
      cargo: "Director Legal, Ciudad de México",
      fecha: "Martes 11 de Marzo, 2025",
      opinion: "La Asesoría Legal fue impecable, resolvieron todas nuestras dudas y agilizaron los trámites de manera eficiente.",
    },
    {
      nombre: "Camila Torres",
      cargo: "Contadora, Monterrey",
      fecha: "Miércoles 12 de Marzo, 2025",
      opinion: "Gracias a la Asesoría Contable mejoramos nuestro flujo de información y recibimos un acompañamiento muy cercano.",
    },
    {
      nombre: "Javier Hernández",
      cargo: "Administrador General, Guadalajara",
      fecha: "Jueves 13 de Marzo, 2025",
      opinion: "La Asesoría Administrativa nos permitió organizar mejor nuestras operaciones y aumentar la eficiencia del equipo.",
    },
    {
      nombre: "Valeria Pérez",
      cargo: "Psicóloga Organizacional, Querétaro",
      fecha: "Viernes 14 de Marzo, 2025",
      opinion: "La Asesoría en Psicología Empresarial ayudó a mejorar el clima laboral y motivación del personal de nuestra empresa.",
    },
    {
      nombre: "Diego Ramírez",
      cargo: "CTO, Ciudad de México",
      fecha: "Sábado 15 de Marzo, 2025",
      opinion: "La Asesoría y Desarrollo de Software nos permitió automatizar procesos internos y mejorar nuestra infraestructura tecnológica.",
    },
  ];

  return (
    <div className="w-full py-12 bg-white flex flex-col items-center">
      <motion.h2
        className="text-purple-900 text-4xl md:text-5xl font-bold mb-8 text-center"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Testimonios de nuestros servicios
      </motion.h2>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4"
      >
        {reseñas.map((res, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-4 text-center px-6 py-8 border rounded-lg shadow-md"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="text-gray-500 text-sm">{res.fecha}</p>

              <h2 className="text-lg md:text-xl font-semibold text-purple-900 leading-relaxed">
                “{res.opinion}”
              </h2>

              <div className="mt-4">
                <p className="text-gray-800 font-medium">{res.nombre}</p>
                <p className="text-gray-500 text-sm">{res.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
